import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { Toaster } from 'react-hot-toast';
import Layout from './components/Layout/Layout';
import WelcomePopup from './components/Common/WelcomePopup';
import HomePage from './pages/HomePage';
import PNRStatusPage from './pages/PNRStatusPage';
import PNRResultPage from './pages/PNRResultPage';
import TrainStatusPage from './pages/TrainStatusPage';
import TrainStatusResultPage from './pages/TrainStatusResultPage';
import TrainInfoPage from './pages/TrainInfoPage';
import TrainInfoResultPage from './pages/TrainInfoResultPage';
import LiveStationPage from './pages/LiveStationPage';
import LiveStationResultPage from './pages/LiveStationResultPage';
import SearchTrainsPage from './pages/SearchTrainsPage';
import SearchTrainsResultPage from './pages/SearchTrainsResultPage';
import './styles/globals.css';
import styles from './App.module.css';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <Router>
        <div className={styles.app}>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              
              {/* PNR Status Routes */}
              <Route path="/pnr-status" element={<PNRStatusPage />} />
              <Route path="/pnr-status/:pnr" element={<PNRResultPage />} />
              
              {/* Train Status Routes */}
              <Route path="/train-status" element={<TrainStatusPage />} />
              <Route path="/train-status/:trainNumber/:date" element={<TrainStatusResultPage />} />
              
              {/* Train Info Routes */}
              <Route path="/train-info" element={<TrainInfoPage />} />
              <Route path="/train-info/:trainNumber" element={<TrainInfoResultPage />} />
              
              {/* Live Station Routes */}
              <Route path="/live-station" element={<LiveStationPage />} />
              <Route path="/live-station/:stationCode" element={<LiveStationResultPage />} />
              
              {/* Search Trains Routes */}
              <Route path="/search-trains" element={<SearchTrainsPage />} />
              <Route path="/search-trains/:from/:to" element={<SearchTrainsResultPage />} />
            </Routes>
          </Layout>

          {/* Welcome Popup - Shows only once */}
          <WelcomePopup />

          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3000,
              style: {
                background: 'var(--card-bg)',
                color: 'var(--text-primary)',
                border: '1px solid var(--border-primary)',
              },
              success: {
                iconTheme: {
                  primary: 'var(--secondary-500)',
                  secondary: '#fff',
                },
              },
              error: {
                iconTheme: {
                  primary: 'var(--primary-500)',
                  secondary: '#fff',
                },
              },
            }}
          />
        </div>
      </Router>
    </ThemeProvider>
  );
};

export default App;